import React from 'react'
import { css } from '@emotion/css'
import { EditorWrap } from './editors/editor-wrap'
import { useUnit } from '../providers/unit.provider'

const containerCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1;
`

const cardCss = css`
  text-align: center;
  padding: 40px;
  max-width: 400px;
`

const titleCss = css`
  font-size: 1.3em;
  font-weight: bold;
  color: #f8fafc;
  margin: 0 0 8px;
`

const messageCss = css`
  color: #94a3b8;
  font-size: 0.95em;
  margin: 0 0 24px;
`

const btnCss = css`
  background: #4f9eff;
  border: none;
  border-radius: 6px;
  padding: 11px 24px;
  color: #fff;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: #3b8fe8; }
`

export const LockedUnitView = () => {
  const { unit, showPaywall } = useUnit()
  if (!unit) return null
  return (
    <EditorWrap opacity={1}>
      <div className={containerCss}>
        <div className={cardCss}>
          <h2 className={titleCss}>{unit.name}</h2>
          <p className={messageCss}>This is a premium unit.</p>
          <button className={btnCss} onClick={showPaywall}>
            Unlock this unit
          </button>
        </div>
      </div>
    </EditorWrap>
  )
}
